// 集团客户授信管理
const customerCreditRouter = {
  path: 'customer-credit',
  name: 'customer-credit',
  component: { render: h => h('router-view') },
  children: [
    {
      path: 'credit-allocation-mana',
      name: 'credit-allocation-mana',
      component: () =>
        import(
          /* webpackChunkName: "credit-allocation-mana" */ '@/views/customer-credit/credit-allocation-mana.vue'
        ),
    },
    {
      path: 'credit-assignment-record',
      name: 'credit-assignment-record',
      component: () =>
        import(
          /* webpackChunkName: "credit-assignment-record" */ '@/views/customer-credit/credit-assignment-record.vue'
        ),
    },
    {
      path: 'account-allocation-mana',
      name: 'account-allocation-mana',
      component: () =>
        import(
          /* webpackChunkName: "account-allocation-mana" */ '@/views/customer-credit/account-allocation-mana.vue'
        ),
    },
    {
      path: 'account-assignment-record',
      name: 'account-assignment-record',
      component: () =>
        import(
          /* webpackChunkName: "account-assignment-record" */ '@/views/customer-credit/account-assignment-record.vue'
        ),
    },
    {
      path: 'group-relationship-mana',
      name: 'group-relationship-mana',
      component: () =>
        import(
          /* webpackChunkName: "group-relationship-mana" */ '@/views/customer-credit/group-relationship-mana.vue'
        ),
    },
    {
      path: 'group-relationship-application',
      name: 'group-relationship-application',
      component: () =>
        import(
          /* webpackChunkName: "group-relationship-application" */ '@/views/customer-credit/apply/group-relationship-application.vue'
        ),
    },
    {
      path: 'relationship-detail/:companyCode',
      name: 'relationship-detail',
      component: () =>
        import(
          /* webpackChunkName: "relationship-detail" */ '@/views/customer-credit/apply/relationship-detail'
        ),
    },
    {
      path: 'approved-approval/:id',
      name: 'approved-approval',
      meta: {
        title: '集团关系审批',
      },
      component: () =>
        import(
          /* webpackChunkName: "approved-approval" */ '@/views/customer-credit/apply/approved-approval'
        ),
    },
    {
      path: 'group-relationship-approved',
      name: 'group-relationship-approved',
      component: () =>
        import(
          /* webpackChunkName: "group-relationship-approved" */ '@/views/customer-credit/apply/group-relationship-approved.vue'
        ),
    },
    {
      path: 'group-relationship-batch-approval',
      name: 'group-relationship-batch-approval',
      component: () =>
        import(
          /* webpackChunkName: "group-relationship-batch-approval" */ '@/views/customer-credit/group-relationship-batch-approval.vue'
        ),
    },
    {
      path: 'group-relationship-batch-application',
      name: 'group-relationship-batch-application',
      component: () =>
        import(
          /* webpackChunkName: "group-relationship-batch-application" */ '@/views/customer-credit/group-relationship-batch-application.vue'
        ),
    },
    {
      path: 'group-relationship-batch-detail/:id',
      name: 'group-relationship-batch-detail',
      component: () =>
        import(
          /* webpackChunkName: "group-relationship-batch-detail" */ '@/views/customer-credit/group-relationship-batch-detail.vue'
        ),
    },
  ],
}

export default customerCreditRouter
